import { useSearchParams } from 'react-router-dom';

import MetricsDashboard from '../../components/metrics/dashboard/metrics-dashboard.component';
import OrderMetrics from '../../components/metrics/order-metrics/order-metrics.component';
import ProductMetrics from '../../components/metrics/product-metrics/product-metrics.component';
import CustomerMetrics from '../../components/metrics/customer-metrics/customer-metrics.component';
import ViewMetrics from '../../components/metrics/view-metrics/view-metrics.component';

import {
    TabContainer,
    TabList,
    TabButton,
    TabPanel
} from './metrics.styles';

const tabs = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'orders', label: 'Orders' },
  { id: 'products', label: 'Products' },
  { id: 'customers', label: 'Customers' },
  { id: 'views', label: 'Views' },
];

const validTabIds = tabs.map(t => t.id);

const MetricsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    const currentTab = validTabIds.includes(tabParam) ? tabParam : 'dashboard';

    const setCurrentTab = (tabId) => {
        setSearchParams({ tab: tabId });
    };

    const renderPanelContent = () => {
        switch (currentTab) {
            case 'dashboard':
                return <MetricsDashboard />;
            case 'orders':
                return <OrderMetrics />;
            case 'products':
                return <ProductMetrics />;
            case 'customers':
                return <CustomerMetrics />;
            case 'views':
                return <ViewMetrics />;
            default:
                return <MetricsDashboard />;
        }
    };

    return (
        <div>
            <TabContainer>
                <TabList>
                    {tabs.map(tab => (
                        <TabButton
                            key={tab.id}
                            active={currentTab === tab.id}
                            onClick={() => setCurrentTab(tab.id)}
                        >
                            {tab.label}
                        </TabButton>
                    ))}
                </TabList>
            </TabContainer>
            <TabPanel>
                {renderPanelContent()}
            </TabPanel>
        </div>
    );
};

export default MetricsPage;
